//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'TinyPagination',
  props: {
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      "default": 1
    },
    lang: {
      type: String,
      "default": 'en'
    },
    customClass: {
      type: String,
      "default": ''
    },
    limits: {
      type: Array,
      "default": function _default() {
        return [10, 15, 20, 50, 100];
      }
    },
    showLimit: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      currentPage: 1,
      currentLimit: 10,
      translations: {
        en: {
          prev: 'Previous',
          title: 'Page',
          next: 'Next'
        },
        es: {
          prev: 'Anterior',
          title: 'Página',
          next: 'Siguiente'
        }
      },
      availableLanguages: ['en', 'es']
    };
  },
  computed: {
    translation: function translation() {
      return this.availableLanguages.includes(this.lang) ? this.translations[this.lang] : this.translations.en;
    },
    totalPages: function totalPages() {
      return Math.ceil(this.total / this.currentLimit);
    },
    titlePage: function titlePage() {
      return "".concat(this.translation.title, " ").concat(this.currentPage);
    },
    classFirstPage: function classFirstPage() {
      return {
        disabled: this.currentPage === 1,
        'c-not-allowed': true
      };
    },
    classLastPage: function classLastPage() {
      return {
        disabled: this.currentPage === this.totalPages,
        'c-not-allowed': true
      };
    }
  },
  watch: {
    currentPage: function currentPage(value) {
      this.$emit('tiny:change-page', {
        page: value
      });
    },
    currentLimit: function currentLimit(value) {
      this.$emit('tiny:change-limit', {
        limit: value
      });
    }
  },
  created: function created() {
    this.currentPage = this.page;
  },
  methods: {
    nextPage: function nextPage() {
      if (this.currentPage !== this.totalPages) {
        this.currentPage += 1;
      }
    },
    lastPage: function lastPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      }
    },
    onLimitChange: function onLimitChange() {
      this.currentPage = 1;
    }
  }
};
function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  }
  // Vue.extend constructor export interop.
  var options = typeof script === 'function' ? script.options : script;
  // render functions
  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true;
    // functional template
    if (isFunctionalTemplate) {
      options.functional = true;
    }
  }
  // scopedId
  if (scopeId) {
    options._scopeId = scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context ||
      // cached call
      this.$vnode && this.$vnode.ssrContext ||
      // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      }
      // inject component styles
      if (style) {
        style.call(this, createInjectorSSR(context));
      }
      // register component module identifier for async chunk inference
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }
  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return script;
}
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });
  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;
    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
      // http://stackoverflow.com/a/26603875
      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }
    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }
      HEAD.appendChild(style.element);
    }
    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "vue-tiny-pagination"
  }, [_c('ul', {
    staticClass: "tiny-pagination",
    "class": _vm.customClass
  }, [_c('li', {
    staticClass: "page-item",
    "class": _vm.classFirstPage
  }, [_c('a', {
    staticClass: "btn-prev-page",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.lastPage($event);
      }
    }
  }, [_vm._v(_vm._s(_vm.translation.prev))])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.titlePage))])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    "class": _vm.classLastPage
  }, [_c('a', {
    staticClass: "btn-next-page",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.nextPage($event);
      }
    }
  }, [_vm._v(_vm._s(_vm.translation.next))])]), _vm._v(" "), _vm.showLimit ? _c('li', {
    staticClass: "page-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentLimit,
      expression: "currentLimit"
    }],
    staticClass: "tiny-form-select",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.currentLimit = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.onLimitChange]
    }
  }, _vm._l(_vm.limits, function (limit, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": limit
      }
    }, [_vm._v(_vm._s(limit) + "/" + _vm._s(_vm.translation.title))]);
  }), 0)]) : _vm._e()])]);
};
var __vue_staticRenderFns__ = [];

/* style */
var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-730f519e_0", {
    source: "@charset \"UTF-8\";.tiny-pagination{font-family:-apple-system,system-ui,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",sans-serif;display:flex;list-style:none;margin:.2rem 0;padding:.2rem 0}.tiny-pagination .page-item{margin:.2rem .05rem}.tiny-pagination .page-item span{display:inline-block;padding:.2rem .2rem}.tiny-pagination .page-item a{border-radius:.1rem;color:#667189;display:inline-block;padding:.2rem .4rem;text-decoration:none}.tiny-pagination .page-item a:focus,.tiny-pagination .page-item a:hover{color:#5755d9}.tiny-pagination .page-item.disabled a{cursor:default;opacity:.5;pointer-events:none}.tiny-pagination .page-item.active a{background:#5755d9;color:#fff}.tiny-pagination .page-item.page-next,.tiny-pagination .page-item.page-prev{flex:1 0 50%}.tiny-pagination .page-item.page-next{text-align:right}.tiny-pagination .page-item .page-item-title{margin:0}.tiny-pagination .page-item .page-item-subtitle{margin:0;opacity:.5}.tiny-pagination .tiny-form-select{-webkit-appearance:none;-moz-appearance:none;appearance:none;text-transform:lowercase;border:.05rem solid #caced7;border-radius:.1rem;font-size:.8rem;height:1.8rem;line-height:1rem;outline:0;padding:.35rem .4rem;vertical-align:middle;width:100%}.tiny-pagination .tiny-form-select:focus{border-color:#5755d9;box-shadow:0 0 0 .1rem rgba(87,85,217,.2)}.tiny-pagination .tiny-form-select:not([multiple]):not([size]){background:#fff url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns=\"http://www.w3.org/2000/svg\"…path%20fill=\"%23667189\"%20d=\"M2%200L0%202h4zm0%205L0%203h4z\"/%3E%3C/svg%3E') no-repeat right .35rem center/.4rem .5rem;padding-right:1.2rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__ = undefined;
/* module identifier */
var __vue_module_identifier__ = undefined;
/* functional template */
var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
__vue_component__.install = function (Vue) {
  Vue.component(__vue_component__.name, __vue_component__);
};
var components = [__vue_component__];
function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
}
var plugin = {
  install: install
};
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}
export default plugin;
export { __vue_component__ as TinyPagination, install };